// Fix AX (2026-10-27): a donde va cada usuario cuando entra o cuando abre una pagina que no le toca.
// (Reemplaza a academyAccess.js: la academia ya no es parte de esta plataforma.)
import { customHome } from "@/lib/customAccess";

export const CLINIC_ROLES = ["admin", "professional", "reception"];

export function isClinicUser(user) {
  return Boolean(user && CLINIC_ROLES.includes(user.role));
}

export function homePath(user) {
  if (isClinicUser(user)) return "/dashboard";
  // Fix AW (2026-10-27): rol personalizado -> su primera seccion
  return customHome(user) || "/perfil";
}
